var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader__bar",class:{ 'active': _vm.active },style:({
		'width': _vm.width +'%'
	})})])}
var staticRenderFns = []

export { render, staticRenderFns }